import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service';

export const canMatchGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userRole = localStorage.getItem('userRole');
  const requiredRoles = route.data?.['roles'] as string[] | undefined;

  // User not logged in
  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (!userRole || !requiredRoles?.includes(userRole)) {
    return router.createUrlTree(['/not-found']);
  }

  return true;
};
